<template>
    <AppDialog :is-open="isDialogOpened"
               :ok-text="$t('common.office.OfficeConversionDialog.conversion')"
               @ok="validateConversionDialog"
               @cancel="closeDialog"
    >
      <template #title>
        <h3 class="conversion-title">{{ $t('common.office.OfficeConversionDialog.title') }}</h3>
      </template>
      <template #body>
        <i18n path="common.office.OfficeConversionDialog.text"
              tag="p"
              class="conversion-text"
        >
          <template v-slot:filderName>
            <b>{{ document.name }}</b>
          </template>
        </i18n>
        <v-checkbox
                v-model="officeConversionAuth"
                hide-details
                :label="$t('common.office.OfficeConversionDialog.checkbox')"
                @update:model-value="checkAuthOfficeConversion($event)"
        />
      </template>
    </AppDialog>
</template>

<script>
import AppDialog from '@/common/dialogs/AppDialog.vue'
import { dialogMixin } from '@/mixins/dialogMixin'

export default {
  name: 'OfficeConversionDialog',
  components: { AppDialog },
  mixins: [dialogMixin],
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      officeConversionAuth: false,
    }
  },
  methods: {
    validateConversionDialog () {
      this.$emit('validate-conversion-dialog', this.officeConversionAuth)
    },
    checkAuthOfficeConversion ($event) {
      this.officeConversionAuth = $event
    },
  },
}
</script>

<style scoped>
h3.conversion-title {
  font-size: 18px;
  color: rgb(var(--v-theme-grey-darken-4));
}
.conversion-text {
  line-height: 20px;
  color: rgb(var(--v-theme-grey-darken-3));
}
label.v-label {
  color: rgb(var(--v-theme-grey-darken-4)) !important
}
</style>
